import { Modal } from "@mui/material";
import styled from "styled-components";
import { COLOR_BLACK, COLOR_GRAY, COLOR_WHITE } from "../../constants/colors";
import { Heading4 } from "../Typography";

const ModalBox = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
  max-width: 600px;
  outline: none;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const ModalContent = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  background: ${COLOR_WHITE};
  border-radius: 10px;
  padding: 50px;

  @media (max-width: 500px) {
    padding: 25px;
  }
`;

const ExitButton = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${COLOR_GRAY};

  @media (max-width: 500px) {
    width: 25px;
    height: 25px;
    top: 5px;
    right: 5px;
  }

  &:after {
    content: "✕";
    font-size: x-large;
    font-weight: bolder;
  }

  &:hover {
    color: ${COLOR_BLACK};
  }
`;

const Title = styled.h1`
  ${Heading4}
  color: ${COLOR_WHITE};
  text-align: center;
`;

type Props = {
  isOpen: boolean;
  handleClose?: () => void;
  children: React.ReactNode;
  title?: string;
};

export default function WhiteModal({ isOpen: open, handleClose, title, children }: Props) {
  return (
    <Modal open={open} onClose={handleClose} disableScrollLock>
      <ModalBox>
        {title && <Title>{title}</Title>}
        <ModalContent>
          <ExitButton onClick={handleClose} />
          {children}
        </ModalContent>
      </ModalBox>
    </Modal>
  );
}
